import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

export default function DisabledUser() {
  return (
    <Container maxWidth="md">
      <Paper elevation={1} sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Account Disabled
        </Typography>
        <Typography variant="body1" gutterBottom>
          Your account is currently disabled and you cannot use the VeraBIND application.
        </Typography>
        <Box mt={1}>
          <Typography variant="body2" color="text.secondary">
            If you believe this is an error, please contact support: support@veravas.com
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
